// @ts-nocheck
import { Selection } from 'prosemirror-state';

export const handleRightArrow = type => (state, dispatch) => {
  const { selection } = state;
  const { $from } = selection;
  const isNullAfter = $from.nodeAfter === null;
  const isCodeBefore = $from.nodeBefore?.marks?.[0]?.type?.name === type.name;
  if (isNullAfter && isCodeBefore) {
    const pos = $from.pos;
    const tr = state.tr.insertText(' ');
    tr.removeMark(pos, pos + 1, type);
    tr.setSelection(Selection.near(tr.doc.resolve(pos), 1));
    dispatch(tr.scrollIntoView());
  }
};
